import { FC, useEffect, useState } from "react"
import { PhotosAndXRays } from "@/UDTreat/components/photos/PhotosAndXRaysForCreatingProcess"
import { useAppSelector, useAppDispatch } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { updateCaseById } from "@/core/app/slices/case/caseThunkApi"
import { useParams } from "react-router-dom"

const Photograph: FC<{
  setPhotographErrors: (value: boolean) => void
  setIsDragEmpty: (value: boolean) => void
  isAlertOpen: boolean
  setIsAlertOpen: (value: boolean) => void
  setIsDragOpen: (Value: boolean) => void
  isDragOpen: boolean
  title: string
  description?: string
  isRefinement?: boolean
  isShowRecords?: boolean
  postMessageUpdate?: () => void
}> = ({ setPhotographErrors }) => {
  const dispatch = useAppDispatch()
  const { caseDetail } = useAppSelector((state: RootState) => state.caseService)
  const { uassist_round } = caseDetail
  const { caseId, patientId } = useParams()
  const { current_orgId } = useAppSelector(
    (state: RootState) => state.userService.user,
  )
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    return () => {
      setPhotographErrors(false)
    }
  }, [])

  useEffect(() => {
    console.log("🚀 ~ useEffect ~ uassist_round:", uassist_round)
    if (uassist_round >= 0) setIsReady(true)
  }, [uassist_round])
  return (
    isReady && (
      <PhotosAndXRays
        isZoomoutAbled={true}
        isDragAbled={true}
        isDeleteAbled={true}
        refinementIndex={uassist_round}
        isCreate={true}
      />
    )
  )
}

export default Photograph
